class CreateArticleUseCase {
    /**
     * @param {ArticleRepository} articleRepository
     */
    constructor(articleRepository) {
        this.articleRepository = articleRepository;
    }

    /**
     * @param {object} articleData
     * @param {string} articleData.category
     * @param {string} articleData.title
     * @param {string} [articleData.link]
     * @param {string} articleData.description
     * @param {File} [articleData.imageFile]
     * @returns {Promise<Article>}
     */
    async execute(articleData) {
        return this.articleRepository.createArticle(articleData);
    }
}

export default CreateArticleUseCase;
